module.exports = __webpack_public_path__ + "static/img/massage_img2.9cb580d6.png";